import type { ContentType, CustomAxis } from "@/types/ab-tests";

export const customAxisOptions: { id: CustomAxis; label: string }[] = [
  { id: "intent", label: "Intent" },
  { id: "keyword", label: "Keyword" },
  { id: "format", label: "Format" },
  { id: "length", label: "Length" },
  { id: "tone", label: "Tone" },
];
